import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import { errorMessage } from '~/utils/utils';
export default /*#__PURE__*/_defineComponent({
  __name: 'BLanguageSwitcher',
  props: {
    light: {
      type: Boolean,
      default: true
    }
  },
  setup: function setup(__props, _ref) {
    var expose = _ref.expose;
    var props = __props;
    var sdk = useSdk();
    var auth = useAuth();
    var router = useRouter();
    var notifier = useNotifier();
    var switchLocalePath = useSwitchLocalePath();
    var _useI18n = useI18n(),
      t = _useI18n.t,
      i18n = _useI18n.i18n;
    var dropdown = ref(false);
    var items = i18n.locales;
    var languageName = computed(function () {
      var locale = i18n.locales.find(function (l) {
        return l.code === i18n.locale;
      });
      return locale ? locale.name : t('error.language.unknown');
    });
    var color = computed(function () {
      return props.light ? 'var(--v-textPrimary-lighten5)' : 'var(--v-textPrimary-base)';
    });
    var isLoggedIn = computed(function () {
      return auth.loggedIn;
    });
    function onDropDown() {
      dropdown.value = !dropdown.value;
    }
    function itemSelected(_x) {
      return _itemSelected.apply(this, arguments);
    }
    function _itemSelected() {
      _itemSelected = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(id) {
        var _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!isLoggedIn.value) {
                _context.next = 4;
                break;
              }
              _context.prev = 1;
              _context.next = 2;
              return sdk.account.updateUser({
                id: auth.user.id
              }, {
                localeCode: id
              });
            case 2:
              _context.next = 4;
              break;
            case 3:
              _context.prev = 3;
              _t = _context["catch"](1);
              notifier.showMessage({
                content: errorMessage(_t, t('errors.saveUserInfo')),
                type: 'error'
              });
            case 4:
              i18n.locale = id;
              dropdown.value = false;
              router.push({
                path: switchLocalePath(id)
              });
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 3]]);
      }));
      return _itemSelected.apply(this, arguments);
    }
    function onClose() {
      dropdown.value = false;
    }
    expose({
      onClose: onClose
    });
    return {
      __sfc: true,
      props: props,
      sdk: sdk,
      auth: auth,
      router: router,
      notifier: notifier,
      switchLocalePath: switchLocalePath,
      t: t,
      i18n: i18n,
      dropdown: dropdown,
      items: items,
      languageName: languageName,
      color: color,
      isLoggedIn: isLoggedIn,
      onDropDown: onDropDown,
      itemSelected: itemSelected,
      onClose: onClose
    };
  }
});